export default __webpack_public_path__ + "static/media/me.3b26e797.png";